import { LocalizedText } from '../../../types/LocalizedTextTypes';

export interface Place {
  name: string;
  address_components: {
    long_name: string;
    short_name: string;
    types: PlaceType[];
  }[];
}

export enum PlaceType {
  street_address = 'street_address',
  route = 'route',
  intersection = 'intersection',
  political = 'political',
  country = 'country',
  establishment = 'establishment',
  administrative_area_level_1 = 'administrative_area_level_1',
  administrative_area_level_2 = 'administrative_area_level_2',
  administrative_area_level_3 = 'administrative_area_level_3',
  administrative_area_level_4 = 'administrative_area_level_4',
  administrative_area_level_5 = 'administrative_area_level_5',
  colloquial_area = 'colloquial_area',
  locality = 'locality',
  sublocality = 'sublocality',
  neighborhood = 'neighborhood',
  premise = 'premise',
  subpremise = 'subpremise',
  plus_code = 'plus_code',
  postal_code = 'postal_code',
  natural_feature = 'natural_feature',
  airport = 'airport',
  park = 'park',
  point_of_interest = 'point_of_interest',
  street_number = 'street_number',
}

export type AddressFormForUpdate = {
  flat?: string;
  floor?: string;
  block?: string;
  streetBuildingEstate1?: string;
  streetBuildingEstate2?: string;
  district?: string;
};

export type AddressInLines = {
  addrLine1: string;
  addrLine2: string;
  addrLine3: string;
  addrLine4: string;
  districtAddress: string;
  country: string;
};
